import { Font, StyleSheet } from '@react-pdf/renderer';
import arial from '../../style/Arial/arial.ttf';
import Noto_Sans from '../../style/Noto_Sans/static/NotoSans-Regular.ttf';
import Han_Sans from '../../style/Han_Sans/static/SourceHanSans-Regular.ttf';
import { fontFamily, width } from '@mui/system';
import { green, red } from '@mui/material/colors';

export enum PdfCrossCheck {
    cross = 'cross',
    check = 'check',
}

Font.register({
    family: 'Han Sans',
    fonts: [
        {
            src: Han_Sans
        },
    ],
});

Font.register({
    family: 'Noto Sans',
    fonts: [
        {
            src: Noto_Sans
        },
    ],
});

export const styles = StyleSheet.create({
    subscript: {
        position: 'relative',
        fontSize: '7',
        lineHeight: 0,
        verticalAlign: 'baseline',
        bottom: '-2.5'
    },
    pageDefault: {
        paddingHorizontal: 20,
        paddingTop: 20,
        paddingBottom: 20,
        fontSize: 8,
        fontFamily: 'Noto Sans',
        display: 'flex',
        flexDirection: 'column',
    },
    pageZh: {
        paddingHorizontal: 20,
        paddingTop: 20,
        paddingBottom: 100,
        fontSize: 8,
        fontFamily: 'Han Sans',
        display: 'flex',
        flexDirection: 'column',
    },
    //Header-------------------------------------------------------------------------
    header: {
        width: '100%',
    },
    headerColumn: {
        width: 'auto'
    },
    headerBold: {
        fontWeight: 'bold',
        fontSize: '10px',
    },
    headerPage: {
        textTransform: 'uppercase',
        fontSize: '10px',
        marginTop: '8px',
    },
    borderBottom: {
        borderBottom: '2px',
        borderColor: '#004652',
        marginBottom: 2,
    },
    rowSpaced: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: '7px',
        paddingBottom: '7px',
    },
    logo_title: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    logoMacraDesign: {
        width: 150,
        height: 30,
        marginRight: 10,
    },
    ms10: { marginLeft: 10 },
    subtitle: {
        fontSize: 8,
    },
    leftLogo: {
        width: 200,
    },
    rightLogo: {
        float: 'right',
        width: 152,
        height: 29,
    },

    //Common-----------------------------------------------------------------------
    justifyContentAround: { justifyContent: 'space-around' },
    boldGreen: {
        fontWeight: 'ultrabold',
        color: '#004652',
        fontSize: 10,
        marginTop: 4,
        marginBottom: 6,
        paddingRight: 10,
        flexWrap: 'wrap',
    },
    boldGreenNote: {
        fontWeight: 'ultrabold',
        color: '#004652',
        fontSize: 10,
        marginTop: 2,  // Ridotto per avvicinare la scritta al contenuto precedente
        marginBottom: 2,  // Ridotto per avvicinare il testo successivo
        paddingRight: 10,
        flexWrap: 'wrap',
    },
    bold: {
        fontWeight: 'ultrabold',
        fontSize: 12,
        marginTop: 4,
    },
    rowCentered: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        maxWidth: '255px',
    },
    gap3: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    //Body-------------------------------------------------------------------------
    body: {
        //backgroundColor: '#E4E4E4',
        width: '100%',

        textAlign: 'justify',
        flexDirection: 'row', // Arrange views in a row
        flexWrap: 'wrap',     // Wrap content to next row when it exceeds the width
        justifyContent: 'space-between',
    },
    rowSpaceBetween: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    flexColumn: {
        width: '33%',         // Set width of each column
        marginBottom: 8,
    },
    flexColumn50: {
        width: '50%',         // Set width of each column
        marginBottom: 8,
    },
    flexColumn90: {
        width: '90%',         // Set width of each column
        marginBottom: 8,
    },
    left: {
        // width: '33%',//<- working alternative
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: 200,
    },

    right: {
        padding: 5,
        // width: '66%', //<- working alternative
        flexShrink: 1,
        flexGrow: 2,
    },
    title: {
        fontSize: 14,
        borderBottom: 1,
        borderColor: '#004652',
        borderBottomStyle: 'solid',
        paddingBottom: 4,
        marginTop: 8,
    },
    map: {
        marginTop: 8,
    },
    section35: {
        padding: 5,
        width: '35%',
    },
    section65: {
        padding: 5,
        width: '65%',
    },
    padding5: { padding: 5 },
    py10: { paddingVertical: 10 },
    py20: { paddingVertical: 20 },
    mt5: { marginTop: 5 },
    rowColor: { backgroundColor: '#DCE2E4' },
    projectSection: {
        padding: 5,
        flexGrow: 1,
        maxWidth: '50%',
    },
    sector: {
        width: '33%',
        textAlign: 'center',
        border: '1px solid #EEE',
    },
    note: { fontSize: 8 },
    disclaimerBox: {
        padding: 7,
        width: '80%',
        marginHorizontal: 'auto',
        marginTop: 10,
        border: '2px solid green',
    },
    disclaimerTitleBox: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 3,
    },
    greenRectangleDisclaimer: {
        height: '100%',
        width: 5,
        backgroundColor: 'green',
    },
    box: {
        border: '3px solid gray',
        padding: 10,
        alignItems: 'center',
        textAlign: 'center',
    },
    checkTitle: {
        fontWeight: 'ultrabold',
        color: '#004652',
        fontSize: 10,
    },
    checkGroupTitle: {
        fontWeight: 900,
        color: '#004652',
        fontSize: 13,
    },
    resultBoxTitle: {
        width: '50%',         // Set width of each column
        marginBottom: -10,
        marginTop: 10,
        border: '3px solid #004652',
        borderBottom: 0,
        padding: '4px',
        textAlign: 'center',
    },
    resultBox: {
        width: '25%',         // Set width of each column
        marginBottom: 10,
        marginTop: 10,
        border: '3px solid #004652',
        padding: '4px',
        textAlign: 'center',
    },
    bl0: {
        borderLeft: 0,
    },
    value: {
        fontSize: 13,
        fontWeight: 700,
    },
    green: {
        color: 'green',
    },
    red: {
        color: 'red',
    },
    ml5: {
        marginLeft: 5,
    },
    //Table material------------------------------------------------------------------------------------------ù
    headerTable: {
        backgroundColor: '#004652',
        color: '#fff',
    },
    borderRow: {
        border: '1px solid #EEE',
        paddingVertical: 3,
        textAlign: 'center',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    notesRow: {
        fontSize: '8px',
        display: 'flex',
        flexDirection: 'row',
        fleWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 0,  // Rimosso margine superiore
        marginBottom: 0,  // Rimosso margine inferiore
        paddingTop: 0,  // Rimosso padding superiore
        paddingBottom: 0,  // Rimosso padding inferiore
    },
    image: {
        width: '10px',
        height: '10px',
    },
    imgCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    //Footer------------------------------------------------------------------------------------------
    footer: {
        position: 'absolute',
        bottom: 10,  // Ridotto per posizionare il footer più vicino al bordo inferiore
        left: 20,
        right: 20,
        borderTop: '1px',  // Ridotto il bordo superiore per minimizzare spazio extra
        borderColor: '#004652',
        paddingTop: 5,  // Ridotto il padding superiore per ridurre l'altezza
        fontSize: 6,  // Ridotto per rendere il testo più piccolo e compatto
    },

});
